import React from "react";

import DestinationSettlementCellContent from "../components/DestinationSettlementCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function destinationSettlement({ width, onResize }: Column.Options) {
	return base(
		ColumnId.DestinationSettlement,
		(item) => <DestinationSettlementCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default destinationSettlement;
